export class Values {
  public static index(data: any, values: any[], dataField: string = 'value'): number {
    if (values == null || values.length == 0) return -1;

    for (var i: number = 0; i < values.length; i++)
      if (values[i].hasOwnProperty(dataField)) if (values[i][dataField] === data) return i;

    return -1;
  }

  public static getIndex(data: any, values: any[], dataField: string = 'value'): number {
    if (values == null) return -1;
    return this.index(data, values, dataField);
  }

  public static getLabel(data: any, values: any[], dataField: string = 'value', labelField: string = 'label'): string {
    if (values == null || values.length == 0) return '';

    let find = values.find((t) => {
      return data === t[dataField];
    }, data);

    return find ? find[labelField] : '';
  }

  public static toArray(enumme: any) {
    return Object.keys(enumme)
      .filter((key) => isNaN(Number(key)) === false)
      .map((key) => enumme[key]);
  }
}
